import _ from 'lodash';
import { deeply } from '../utils/map-data';
export default {
  fromApi: function fromApi(data) {
    return deeply(data, function (obj) {
      return _.mapKeys(obj, function (value, key) {
        return _.camelCase(key);
      });
    });
  },
  toApi: function toApi(data) {
    return deeply(data, function (obj) {
      return _.mapKeys(obj, function (value, key) {
        return _.snakeCase(key);
      });
    });
  }
};